var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`help ${_vm.$route.name != 'HelpHome' ? 'child-route' : ''}`},[(_vm.$route.name != 'HelpHome')?_c('div',{staticClass:"help-panels"},[_c('HelpMenu'),_c('router-view',{staticClass:"help-router-view"}),_c('Footer')],1):[_c('router-view'),_c('Footer')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }